/** Скільки лишилось до дати — людською мовою.
 *
 * Owner 2026-09-04: «начиная с 23:59 часов должно уже в часах и минутах и
 * секундах писать, когда осталось 24 часа и меньше». Тобто поки далеко —
 * рахуємо днями, а коли доба й менше — тікає таймер, посекундно.
 */
import { useEffect, useState } from "react";

function plural(n: number, one: string, few: string, many: string): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
}

function pad(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

/** Готовий підпис: `через 4 дні` / `через 07:12:45` / `вже зараз`. */
export function countdownLabel(iso?: string, now: number = Date.now()): string {
  if (!iso) return "";
  const ms = new Date(iso).getTime() - now;
  if (ms <= 0) return "вже зараз";
  if (ms >= 86400000) {
    // Округлюємо ВГОРУ: поки не минула повна доба, це ще «1 день», а не «0».
    const days = Math.ceil(ms / 86400000);
    return `через ${days} ${plural(days, "день", "дні", "днів")}`;
  }
  const s = Math.floor(ms / 1000);
  return `через ${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
}

/** Той самий підпис, але живий: під добою оновлюється щосекунди, далі — раз
 *  на хвилину (щоб не перемальовувати екран дарма). */
export function useCountdown(iso?: string): string {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!iso) return;
    const left = new Date(iso).getTime() - Date.now();
    const step = left > 86400000 ? 60000 : 1000;
    const t = setInterval(() => setNow(Date.now()), step);
    return () => clearInterval(t);
  }, [iso, now > 0 && iso ? new Date(iso).getTime() - now > 86400000 : false]);
  return countdownLabel(iso, now);
}
